import {createGlobalStyle} from 'styled-components';

export default createGlobalStyle`
* {
    margin:0;
    padding: 0;
    box-sizing: border-box;

}

body{
    background: '#080000';
    font-size: 14px;
    color: '#fff';
    font-family: sans-serif;
}

`;